import {debounce} from './Utils';

const $ = jQuery;

export default class Carousel {
    constructor() {
        this.initCarousel();
    }
    initCarousel() {
        $('.carousel').each((i, node) => {
            const DURATION = parseInt($(node).attr('data-autoplay'), 10);
            node._autoplayDuration = DURATION;
            node._autoplay = null;
            node._touchStartX = 0;
            node._touchEndX = 0;
            node._touchStartY = 0;
            node._touchEndY = 0;
            $(node).on('touchstart', '.carousel__item', (event) => this._onTouchStart(event, node));
            $(node).on('touchend', '.carousel__item', (event) => this._onTouchEnd(event, node));
            if (isNaN(DURATION)) {
                return;
            }
            this._autoplaySlides(node, DURATION);
            $(node).on('click mouseleave', '.carousel__bullet', (event) => this._restartAnimation(node));
            $(node).on('mouseleave', '.carousel__item', (event) => this._restartAnimation(node));
            $(node).on('mouseenter', '.carousel__item', (event) => clearTimeout(node._autoplay));
        });
    }
    _autoplaySlides(carousel, DURATION) {
        carousel._autoplay = setTimeout(() => {
            let $slides = $(carousel).find('.carousel__trigger'),
                $current = $slides.filter(':checked'),
                index = $slides.index($current),
                next = index + 1 > $slides.length - 1 ? 0 : index + 1;
            $slides.prop('checked', false).eq(next).prop('checked', true);
            this._autoplaySlides(carousel);
        }, carousel._autoplayDuration);
    }
    _restartAnimation(carousel) {
        clearTimeout(carousel._autoplay);
        this._autoplaySlides(carousel);
    }
    _onTouchStart(event, carousel) {
        carousel._touchStartX = event.originalEvent.changedTouches[0].screenX;
        carousel._touchStartY = event.originalEvent.changedTouches[0].screenY;
    }
    _onTouchEnd(event, carousel) {
        carousel._touchEndX = event.originalEvent.changedTouches[0].screenX;
        carousel._touchEndY = event.originalEvent.changedTouches[0].screenY;
        this._handleGesture(carousel);
    }
    _handleGesture(carousel) {
        const DISTANCE_X = carousel._touchStartX - carousel._touchEndX;
        const DISTANCE_Y = carousel._touchStartY - carousel._touchEndY;
        let swipe = 0;

        if (DISTANCE_Y > 100) {
            return;
        }
        if (DISTANCE_X > 20) {
            swipe = 1;
        }
        if (DISTANCE_X < -20) {
            swipe = -1;
        }
        if (swipe === 0) {
            return;
        }
        let $items = $(carousel).find('.carousel__trigger'),
            current = $items.index($items.filter(':checked')),
            max = $items.length - 1,
            next = current + swipe;
        if (next < 0) {
            next = max;
        }
        if (next > max) {
            next = 0;
        }
        $items.prop('checked', false).eq(next).prop('checked', true);
        if (carousel._autoplayDuration > 0) {
            this._restartAnimation(carousel);
        }
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/modules/Carousel.js